<template>
  <!-- 项目管理 -->
  <div class="paddbox autobox">
    <div>
      <el-card>
        <!-- 第一行：选择配置 / 选择任务 -->
        <div class="tool-row">
          <el-button type="warning" size="small" @click="selectStrategyFun">配置复用</el-button>
          <!-- <el-button type="warning" size="small" @click="fuzhiFun">赋值</el-button> -->
          <!-- <el-button type="primary" size="small" @click="selectTaskFun">选择任务</el-button> -->

          <!-- 已选任务回显 -->
          <div v-if="selectedTask" class="selected-item">
            <span class="selected-label">已选「任务」:</span>
            <el-tooltip :content="selectedTask" placement="top" :show-after="200">
              <span class="selected-text">{{ selectedTask }}</span>
            </el-tooltip>
            <span class="selected-close" @click="selectedTask = ''">×</span>
            <el-button type="text" size="small" @click="selectTaskFun">更改</el-button>
          </div>
          <div v-if="selectedStrategy" class="selected-item">
            <span class="selected-label">已选「配置」:</span>
            <el-tooltip :content="selectedStrategy" placement="top" :show-after="200">
              <span class="selected-text">{{ selectedStrategy }}</span>
            </el-tooltip>
            <span class="selected-close" @click="selectedStrategy = ''">×</span>
            <el-button type="text" size="small" @click="selectStrategyFun">更改</el-button>
          </div>
        </div>

        <!-- 第二行：媒体账户 / 创量项目 / 项目生成规则 -->
        <div class="tool-row">
          <!-- 媒体账户 -->
          <div class="group-box">
            <div class="group-label">媒体账户</div>
            <div class="group-content">
              <template v-if="config.mediaAccountList.length > 0">
                <el-tooltip :content="mediaAccountNames" placement="top" :show-after="200">
                  <span class="group-text">{{ mediaAccountNames }}</span>
                </el-tooltip>
                <span class="group-count">已选 {{ config.mediaAccountList.length }} 个</span>
              </template>
              <span v-else class="group-placeholder">未选择媒体账户</span>
              <el-button type="text" size="small" @click="mediaAccountView = true">更改</el-button>
            </div>
          </div>

          <!-- 创量项目 -->
          <!-- <div class="group-box">
            <div class="group-label">创量项目</div>
            <div class="group-content">
              <el-tooltip :content="chuangliangProject" placement="top" :show-after="200">
                <span class="group-text">{{ chuangliangProject || '未选择创量项目' }}</span>
              </el-tooltip>
              <el-button type="text" size="small" @click="selectChuangliangProjectFun">更改</el-button>
            </div>
          </div> -->

          <!-- 项目生成规则 -->
          <div class="group-box">
            <div class="group-label">
              项目生成规则
              <el-tooltip content="选择项目生成的拆分规则" placement="top">
                <el-icon class="help-icon">
                  <QuestionFilled />
                </el-icon>
              </el-tooltip>
            </div>
            <div class="group-content">
              <el-radio-group v-model="projectRule" size="small">
                <!-- <el-radio-button label="byDouyinOrProduct">按抖音号或商品数量</el-radio-button> -->
                <el-radio-button label="byDouyinXProduct">按抖音号数×商品数</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <!-- 投放内容 -->
    <div>
      <el-card class="section-card content-card" shadow="never">
        <template #header>
          <div class="section-header">
            <div class="section-title-wrap">
              <span class="section-title">投放内容</span>
              <span class="section-subtitle">按 4 步顺序填写即可创建，带 <i class="req">*</i> 为必填</span>
            </div>
            <div class="section-steps-hint">
              <span class="hint-item">01 剧目</span>
              <span class="hint-dot">·</span>
              <span class="hint-item">02 商品</span>
              <span class="hint-dot">·</span>
              <span class="hint-item">03 素材账号</span>
              <span class="hint-dot">·</span>
              <span class="hint-item">04 确认提交</span>
            </div>
          </div>
        </template>
        <div class="section-body">
          <!-- STEP 01 -->
          <div class="content-step">
            <div class="step-head">
              <span class="step-num">01</span>
              <div class="step-text">
                <div class="step-title">剧目与平台 <span class="step-tag">先选这里</span></div>
                <div class="step-desc">先确定平台与变现模式，再挑选要投放的专辑链接。专辑链接决定了后面可选的营销产品。</div>
              </div>
              <span class="step-state" :class="{ done: config.platformCode && products.length > 0 }">
                {{ config.platformCode && products.length > 0 ? '已完成' : '待填写' }}
              </span>
            </div>
            <div class="step-grid grid-2">
              <div class="field-card">
                <div class="field-card-head">
                  <span class="field-card-label">短剧平台 <i class="req">*</i></span>
                  <span class="field-card-tip">决定可投的专辑范围</span>
                </div>
                <el-select v-model="config.platformCode" clearable @click="bookplatformListFun()" placeholder="请选择短剧平台"
                  style="width:100%">
                  <el-option v-for="item in config.platformList" :key="item.platformCode" :label="item.platformName"
                    :value="item.platformCode"></el-option>
                </el-select>
              </div>
              <div class="field-card">
                <div class="field-card-head">
                  <span class="field-card-label">变现模式 <i class="req">*</i></span>
                  <span class="field-card-tip">IAP 为用户付费，混合为 IAA+IAP</span>
                </div>
                <el-radio-group v-model="config.monetizeMode" size="small">
                  <el-radio-button :label="'IAP'">用户付费(IAP)</el-radio-button>
                  <el-radio-button :label="'IAA_AND_IAP'">混合投放(IAA+IAP)</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <!-- 专辑链接 -->
            <div class="field-card is-full">
              <div class="field-card-head">
                <span class="field-card-label">专辑链接 <i class="req">*</i></span>
                <span class="field-card-tip">挑选本单要投的剧，需与营销产品数量保持一致</span>
                <span class="head-spacer"></span>
                <el-button type="warning" size="small" @click="albumLinkViewFun()">选择专辑链接</el-button>
                <span v-show="products.length > 0" class="selected-count-text">
                  已选 <b class="num-blue">{{ products.length }}</b> 个
                  <el-button type="text" size="small" class="clear-link-btn" @click="clearproductss()">清空</el-button>
                </span>
              </div>
              <div v-show="products.length > 0" class="selected-album-list">
                <div class="selected-album-item" v-for="(item, idx) in products" :key="item.dramaId">
                  <span class="album-index">{{ idx + 1 }}</span>
                  <div class="album-info">
                    <div class="selected-album-title">{{ item.dramaName }}</div>
                    <div class="selected-album-id">ID：{{ item.dramaId }}</div>
                  </div>
                  <span class="selected-album-remove" @click="removeproducts(item.dramaId)">×</span>
                </div>
              </div>
              <div v-show="products.length === 0" class="empty-box" @click="albumLinkViewFun()">
                <span class="empty-icon">＋</span>
                <span class="empty-text">还没有选择专辑，点击选择专辑链接</span>
                <span class="empty-sub">需先选择上方「短剧平台」</span>
              </div>
            </div>
          </div>

          <!-- STEP 02 -->
          <div class="content-step">
            <div class="step-head">
              <span class="step-num">02</span>
              <div class="step-text">
                <div class="step-title">商品与归属</div>
                <div class="step-desc">确定组织、商品库和营销产品，营销产品数量要和专辑链接一一对应。</div>
              </div>
              <span class="step-state"
                :class="{ done: config.orgAccountName && config.platformId && config.selectedMarketingProductList.length > 0 }">
                {{ config.orgAccountName && config.platformId && config.selectedMarketingProductList.length > 0 ? '已完成'
                  :
                  '待填写'
                }}
              </span>
            </div>
            <div class="step-grid grid-2">
              <div class="field-card">
                <div class="field-card-head">
                  <span class="field-card-label">组织名称 <i class="req">*</i></span>
                  <span class="field-card-tip">素材与商品库都归属该组织---如果数据为空需要找组长去《工作台组织-升级版》授权</span>
                </div>
                <div class="select-display-box select-full" @click="setSpTypeFun()">
                  <span v-show="config.orgAccountName">{{ config.orgAccountName }}</span>
                  <span v-show="!config.orgAccountName" class="placeholder-text">请选择组织账户</span>
                  <el-icon class="select-arrow">
                    <ArrowDown />
                  </el-icon>
                </div>
              </div>
              <div class="field-card">
                <div class="field-card-head">
                  <span class="field-card-label">商品库 <i class="req">*</i></span>
                  <el-button v-show="config.platformId != ''" type="text" size="small"
                    @click="librarylistFun()">刷新商品库</el-button>
                </div>
                <el-select v-model="config.platformId" filterable placeholder="请先选组织，再选商品库" clearable size="small"
                  style="width: 100%">
                  <el-option v-for="item in config.productLibraryOptions" :key="item.platformId" :label="item.name"
                    :value="item.platformId" />
                </el-select>
              </div>
            </div>
            <div class="field-card is-full">
              <div class="field-card-head">
                <span class="field-card-label">营销产品 <i class="req">*</i></span>
                <span class="field-card-tip">数量需与专辑链接一致（当前专辑 {{ products.length }} 个）</span>
                <span class="head-spacer"></span>
                <el-button type="text" size="small" @click="jumpspglFun()">商品不存在？点击开启新页面添加</el-button>
                <el-button type="warning" size="small" @click="openYXCPFun()">选择营销产品</el-button>
                <span v-show="config.selectedMarketingProductList.length > 0" class="selected-count-text">
                  已选 <b class="num-blue">{{ config.selectedMarketingProductList.length }}</b> 个
                  <el-button type="text" size="small" class="clear-link-btn"
                    @click="clearMarketingProducts">清空</el-button>
                </span>
              </div>
              <div v-show="config.selectedMarketingProductList.length > 0" class="selected-album-list">
                <div class="selected-album-item" v-for="(item, idx) in config.selectedMarketingProductList"
                  :key="item.id">
                  <span class="album-index green">{{ idx + 1 }}</span>
                  <div class="album-info">
                    <div class="selected-album-title">{{ item.productName }}</div>
                    <div class="selected-album-id">ID：{{ item.productId }}</div>
                  </div>
                  <span class="selected-album-remove" @click="removeMarketingProduct(item.productId)">×</span>
                </div>
              </div>
              <div v-show="config.selectedMarketingProductList.length === 0" class="empty-box" @click="openYXCPFun()">
                <span class="empty-icon">＋</span>
                <span class="empty-text">还没有选择营销产品，点击选择</span>
                <span class="empty-sub">需先选择「商品库」</span>
              </div>
            </div>
            <div class="field-card is-full slim">
              <div class="field-card-head">
                <span class="field-card-label">视频主页可见性</span>
                <span class="field-card-tip">控制广告在作者主页的展示方式</span>
              </div>
              <el-radio-group v-model="config.hideHomeAd" size="small">
                <el-radio-button :label="1">主页始终可见</el-radio-button>
                <el-radio-button :label="0">仅单次展示可见</el-radio-button>
              </el-radio-group>
            </div>
          </div>

          <!-- STEP 03 -->
          <div class="content-step">
            <div class="step-head">
              <span class="step-num">03</span>
              <div class="step-text">
                <div class="step-title">素材 · 账号 · 基础信息</div>
                <div class="step-desc">每个营销产品都要配创意素材，再指定抖音号并填写投放基础信息。</div>
              </div>
              <span class="step-state" :class="{ done: materialTotalCount > 0 && isDouyinDone && config.hasBaseInfo }">
                {{ materialTotalCount > 0 && isDouyinDone && config.hasBaseInfo ? '已完成' : '待填写' }}
              </span>
            </div>

            <div class="field-card is-full">
              <div class="field-card-head">
                <span class="field-card-label">创意素材 <i class="req">*</i></span>
                <span class="field-card-tip">按营销产品逐个配素材，全部配完才能提交</span>
                <span class="head-spacer"></span>
                <el-button type="warning" size="small" @click="openCreativeMaterialFun">选择创意素材</el-button>
                <span v-show="materials.length > 0" class="material-count-text">
                  <span class="num-blue">{{ materialGroupCount }}</span> 组 / 一共 <span class="num-blue">{{
                    materialTotalCount
                  }}</span> 条
                </span>
              </div>
              <div v-show="config.sucaiListCheck === false" class="empty-box" @click="openCreativeMaterialFun()">
                <span class="empty-icon">＋</span>
                <span class="empty-text">还没有素材，点击选择创意素材</span>
                <span class="empty-sub">需先选择上方「营销产品」</span>
              </div>
              <div v-show="materials.length > 0" class="material-mini-list">
                <div class="material-mini-item" v-for="m in materials" :key="m.productId"
                  :class="{ ok: m.sucai && m.sucai.length > 0 }">
                  <span class="mini-dot"></span>
                  <el-tooltip :content="m.productName" placement="top" :show-after="300">
                    <span class="mini-name">{{ m.productName }}</span>
                  </el-tooltip>
                  <span class="mini-count">{{ m.sucai ? m.sucai.length : 0 }} 条</span>
                </div>
              </div>
              <!-- <div v-else class="empty-hint">请先选择营销产品，再来配置创意素材</div> -->
            </div>

            <div class="step-grid grid-2">
              <div class="field-card">
                <div class="field-card-head">
                  <span class="field-card-label">抖音号分配</span>
                </div>
                <el-radio-group v-model="douyinSelectType" size="small">
                  <el-radio-button :label="0">统一应用</el-radio-button>
                  <el-radio-button :label="1">分账户指定</el-radio-button>
                </el-radio-group>
              </div>
              <div class="field-card" v-if="douyinSelectType === 0">
                <div class="field-card-head">
                  <span class="field-card-label">抖音号 <i class="req">*</i></span>
                  <!-- <el-button type="text" size="small" @click="douyinAccountView = true">没有？点我创建</el-button> -->
                </div>
                <el-select v-model="config.douyinIds" multiple filterable clearable placeholder="请选择抖音号（可多选）"
                  size="small" style="width: 100%" @visible-change="onDouyinVisibleChange">
                  <el-option v-for="item in config.douyinOptions" :key="item.douyinId" :label="item.douyinName"
                    :value="item.douyinId" />
                </el-select>
                <div v-show="config.douyinIds.length > 0" class="inline-count">已选 {{ config.douyinIds.length }} 个抖音号
                </div>
              </div>
              <div class="field-card" v-else>
                <div class="field-card-head">
                  <span class="field-card-label">按账户指定抖音号 <i class="req">*</i></span>
                  <span class="head-spacer"></span>
                  <el-button type="warning" size="small" @click="openAccountDouyinFun">选择抖音号</el-button>
                </div>
                <div class="per-account-summary">
                  <span>已配置 <b class="num-blue">{{ configuredAccountCount }}</b>/{{ config.accountIds.length }}
                    个账户</span>
                  <el-button type="text" size="small" class="clear-link-btn"
                    @click="clearAccountDouyinFun">清空</el-button>
                </div>
                <div v-if="config.accountIds.length === 0" class="empty-hint">请先在顶部选择媒体账户，再点击「选择抖音号」为每个账户指定</div>
              </div>
            </div>

            <div class="field-card is-full">
              <div class="field-card-head">
                <span class="field-card-label">基础信息 <i class="req">*</i></span>
                <span class="field-card-tip">预算、ROI、定向、标题包等都在这里设置</span>
                <span class="head-spacer"></span>
                <el-button type="warning" size="small" @click="baseInfoView = true">{{ config.hasBaseInfo ? '修改基础信息' :
                  '选择基础信息'
                }}</el-button>
              </div>
              <div v-show="config.hasBaseInfo === false" class="empty-box" @click="baseInfoView = true">
                <span class="empty-icon">＋</span>
                <span class="empty-text">还没有基础信息，点击选择基础信息</span>
                <span class="empty-sub"></span>
              </div>
              <div v-show="config.hasBaseInfo" class="config-summary-box">
                <div class="config-summary-item">
                  <span class="summary-label">日预算：</span>
                  <span class="summary-value">{{ config.budget }} 元/天</span>
                </div>
                <div class="config-summary-item">
                  <span class="summary-label">ROI：</span>
                  <span class="summary-value">{{ config.uniRoiGoal }}</span>
                </div>
                <div class="config-summary-item">
                  <span class="summary-label">AIGC动态创意：</span>
                  <span class="summary-value">{{ Number(config.aigcEnabled) === 1 ? '启用' : '停用' }}</span>
                </div>
                <div class="config-summary-item">
                  <span class="summary-label">标题包：</span>
                  <el-tooltip :content="config.titlePackageName" placement="top" :show-after="200">
                    <span class="summary-value">{{ config.titlePackageName || '未选择' }}</span>
                  </el-tooltip>
                </div>
                <div class="config-summary-item">
                  <span class="summary-label">定向包：</span>
                  <el-tooltip :content="configDirectionalPackageText" placement="top" :show-after="200">
                    <span class="summary-value">{{ configDirectionalPackageText }}</span>
                  </el-tooltip>
                </div>
                <div class="config-summary-item">
                  <span class="summary-label">投放时间：</span>
                  <span class="summary-value">{{ configScheduleText }}</span>
                </div>
                <div class="config-summary-item">
                  <span class="summary-label">产品主图：</span>
                  <el-tooltip :content="config.productMainImageName" placement="top" :show-after="200">
                    <span class="summary-value">{{ config.productMainImageName || '未选择' }}</span>
                  </el-tooltip>
                </div>
                <div class="config-summary-item">
                  <span class="summary-label">项目状态：</span>
                  <span class="summary-value">{{ Number(config.status) === 1 ? '启用' : '停用' }}</span>
                </div>
                <div class="config-summary-item">
                  <span class="summary-label">自定义抖音号名称：</span>
                  <el-tooltip :content="config.customDouyinName" placement="top" :show-after="200">
                    <span class="summary-value">{{ config.customDouyinName || '未填写' }}</span>
                  </el-tooltip>
                </div>
              </div>
              <div v-show="!config.hasBaseInfo" class="empty-hint">还没有填写基础信息，点击上方按钮去设置预算、定向等</div>
            </div>
          </div>

          <!-- STEP 04 -->
          <div class="content-step submit-step">
            <div class="step-head">
              <span class="step-num">04</span>
              <div class="step-text">
                <div class="step-title">命名并创建</div>
                <div class="step-desc">取一个好找的名字，检查无误后提交。提交前会校验专辑数 = 营销产品数。</div>
              </div>
            </div>
            <div class="field-card is-full">
              <div class="field-card-head">
                <span class="field-card-label">配置名称 <i class="req">*</i></span>
                <span class="field-card-tip">建议包含剧名 + 日期，方便后续查找</span>
              </div>
              <el-input v-model="config.configName" placeholder="请输入配置名称，例如：XX短剧-混合投放-0912" clearable
                style="width: 100%; max-width: 520px" />
            </div>
            <div class="submit-bar">
              <div class="submit-summary">
                <span>专辑 <b>{{ products.length }}</b></span>
                <span class="sep">|</span>
                <span>营销产品 <b>{{ config.selectedMarketingProductList.length }}</b></span>
                <span class="sep">|</span>
                <span>素材 <b>{{ materialTotalCount }}</b> 条</span>
                <span class="sep">|</span>
                <span>抖音号 <b>{{ douyinTotalCount }}</b> 个</span>
              </div>
              <el-button type="success" class="submit-btn" @click="globalAdConfigaddFun()">确定创建</el-button>
            </div>
          </div>




        </div>
      </el-card>
    </div>

    <!-- 选择创意素材弹窗 -->
    <el-dialog v-model="creativeMaterialView" title="选择创意素材" width="80%">
      <div class="creative-toolbar">
        <div class="creative-toolbar-left">
          <span v-if="autoMatchTip" class="auto-match-tip" :class="`auto-match-tip--${autoMatchTipType}`">{{
            autoMatchTip
            }}</span>
        </div>
        <div class="creative-toolbar-right">
          <span class="auto-match-warn">素材自动匹配前{{ autoMatchMaxCount }}条组织素材；自动匹配轮询时，请勿关闭弹窗。</span>
          <el-button type="primary" plain size="small" :loading="autoMatchLoading" :disabled="autoMatchLoading"
            @click="openAutoMatchCountDialog()">自动匹配素材</el-button>
        </div>
      </div>
      <el-table :data="materials" border style="width: 100%">
        <el-table-column prop="productName" label="商品名称" min-width="200" show-overflow-tooltip />
        <el-table-column label="素材状态" width="160">
          <template #default="scope">
            <span v-if="scope.row.sucai.length === 0" class="status-unselected">未选中</span>
            <span v-else class="status-selected">已选中 {{ scope.row.sucai.length }} 个素材</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template #default="scope">
            <el-button type="primary" size="mini" @click="openSucaiSelectFun(scope)">选择素材</el-button>
            <el-button type="danger" size="mini" @click="clearSucaiConfirmFun(scope)">清空素材</el-button>
          </template>
        </el-table-column>
        <el-table-column label="素材预览" min-width="320">
          <template #default="scope">
            <div v-if="scope.row.sucai.length > 0" class="sucai-preview-list">
              <div class="sucai-preview-item" v-for="(su, index) in scope.row.sucai.slice(0, 10)" :key="index">
                <img :src="su.posterUrl" class="sucai-preview-img" />
              </div>
              <span v-if="scope.row.sucai.length > 10" class="sucai-preview-more">+{{ scope.row.sucai.length - 10
              }}</span>
            </div>
            <span v-else class="sucai-preview-empty">暂未选择素材</span>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="creativeMaterialView = false">取消</el-button>
        <el-button type="primary" @click="confirmCreativeMaterialFun">确定</el-button>
      </template>
    </el-dialog>

    <!-- 自动匹配素材数量弹窗 -->
    <el-dialog v-model="autoMatchCountView" title="自动匹配素材" width="420px" append-to-body>
      <div class="auto-match-count-row">
        <span class="auto-match-count-label">素材匹配数量</span>
        <el-input-number v-model="autoMatchMaxCount" :min="1" :max="200" :step="1" step-strictly
          placeholder="请输入素材匹配数量" style="width: 180px" />
        <span class="auto-match-count-unit">条</span>
      </div>
      <div class="auto-match-count-tip">每个商品取素材库前 {{ autoMatchMaxCount || 0 }} 条组织素材进行匹配，最大 200 条</div>
      <template #footer>
        <el-button size="small" @click="autoMatchCountView = false">取消</el-button>
        <el-button type="primary" size="small" @click="confirmAutoMatchCountFun()">确定匹配</el-button>
      </template>
    </el-dialog>

    <!-- 选择素材弹窗：dialog 归父页面管，组件只管内容；v-if + destroy-on-close 保证每次打开都是全新实例 -->
    <el-dialog v-model="sucaiSelectView" title="选择素材" width="80%" destroy-on-close append-to-body>
      <ylySucaiSelector v-if="sucaiSelectView"
        :advertiser-id="config.accountIds && config.accountIds.length > 0 ? config.accountIds[0] : ''"
        :default-material-name="currentMaterialRow ? currentMaterialRow.productName || '' : ''"
        :checked-list="currentMaterialRow ? currentMaterialRow.sucai || [] : []" @confirm="handleSucaiConfirmFun"
        @cancel="sucaiSelectView = false"></ylySucaiSelector>
    </el-dialog>

    <!-- 选择专辑链接弹窗 -->
    <el-dialog v-model="albumLinkView" title="选择专辑链接" width="70%" destroy-on-close>
      <ylylinkCheck v-if="albumLinkView" :data="albumLinkParamData" :linkCheckData="config.linkCheckData"
        @linkCheckDataFun="linkCheckDataFun">
      </ylylinkCheck>
    </el-dialog>



    <!-- 选择营销产品弹窗 -->
    <el-dialog v-model="marketingProductView" title="选择营销产品" width="70%">
      <ylySelectProducts :data="marketingProdu_product" @SPproductData="SPproductData"></ylySelectProducts>
    </el-dialog>



    <!-- 选择媒体账户弹窗 -->
    <el-dialog v-model="mediaAccountView" title="选择媒体账户" width="40%">
      <insertViewBatchTrim @getDataListFun="getSonAccountListFun" :datas="config.accountIds"
        :descParam="config.accountIdsDesc" @getCannelFun="mediaAccountView = false"></insertViewBatchTrim>
    </el-dialog>


    <!-- 选择组织账户弹窗 -->
    <el-dialog v-model="orgAccountView" title="选择组织账户" width="70%">
      <ylyOrganizationTree :datas="OrganizationTreeAge" @getOrgData="getOrgData"></ylyOrganizationTree>
    </el-dialog>

    <!-- 抖音号管理弹窗 -->
    <el-dialog v-model="douyinAccountView" title="抖音号管理" width="70%">
      <ylyDouyingAccount />
    </el-dialog>

    <!-- 基础信息 -->
    <el-dialog v-model="baseInfoView" title="基础信息" width="80%" destroy-on-close>
      <ylyBasicDataConifg :data="config" @update:config="receiveConfigFun" />
    </el-dialog>

    <!-- 选择配置弹窗 -->
    <el-dialog v-model="strategySelectView" title="选择配置" width="70%" destroy-on-close>
      <div class="strategy-toolbar">
        <el-input v-model="strategySearchName" placeholder="请输入配置名称" clearable style="width: 260px"
          @keyup.enter="strategySearchFun" />
        <el-button type="primary" size="small" @click="strategySearchFun">查询</el-button>
        <el-button type="success" size="small" class="strategy-confirm-btn"
          @click="confirmStrategySelectFun">确定</el-button>
      </div>
      <el-table :data="strategyTableData" border stripe highlight-current-row v-loading="strategyLoading"
        element-loading-text="加载中..." empty-text="暂无配置数据" style="width: 100%"
        @current-change="handleStrategyCurrentChange" :row-key="(row) => row.configId ?? row.id">
        <el-table-column label="" width="55" align="center">
          <template #default="scope">
            <el-radio :label="scope.row.configId ?? scope.row.id" v-model="selectedStrategyId"
              @change="() => handleStrategyCurrentChange(scope.row)">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="configId" label="配置ID" width="90" align="center" />
        <el-table-column prop="configName" label="配置名称" min-width="220" show-overflow-tooltip />
        <el-table-column label="执行情况" width="110" align="center">
          <template #default="scope">
            <el-tag v-if="Number(scope.row.status) === 1" type="success" size="small">执行成功</el-tag>
            <el-tag v-else type="danger" size="small">执行失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="total" label="任务总数" width="110" align="center" />
        <el-table-column label="成功 / 失败" width="130" align="center">
          <template #default="scope">
            <span class="num-blue">{{ scope.row.successCount ?? 0 }}</span>
            <span> / </span>
            <span>{{ scope.row.failCount ?? 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" align="center" show-overflow-tooltip />
      </el-table>
      <div class="pagination strategy-pagination">
        <pagination @handleSizeChange="strategyHandleSizeChange" @handleCurrentChange="strategyHandleCurrentChange"
          :total="strategyTotal" :pagesize="strategyPageSize" :currentPage="strategyPage"></pagination>
      </div>
    </el-dialog>

    <!-- 分账户指定抖音号弹窗 -->
    <el-dialog v-model="accountDouyinView" title="分账户指定抖音号" width="70%" destroy-on-close>
      <el-table :data="accountDouyinMap" border style="width: 100%" empty-text="请先选择媒体账户">
        <el-table-column label="账户" min-width="240">
          <template #default="scope">
            <div class="account-cell-name">{{ getAccountNameById(scope.row.accountId) }}</div>
            <div class="account-cell-id">ID：{{ scope.row.accountId }}</div>
          </template>
        </el-table-column>
        <el-table-column label="已选抖音号" min-width="320">
          <template #default="scope">
            <el-select :model-value="scope.row.douyinIds"
              @update:model-value="(val) => onAccountDouyinChange(scope.row.accountId, val)" multiple filterable
              clearable placeholder="请选择抖音号" size="small" style="width: 100%"
              :loading="!!awemeLoadingMap[scope.row.accountId]"
              @visible-change="(v) => onAwemeVisibleChange(v, scope.row)">
              <el-option v-for="item in (awemeOptionsMap[scope.row.accountId] || scope.row.douyinOptions || [])" :key="item.value"
                :label="item.label" :value="item.value" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="数量" width="90" align="center">
          <template #default="scope">
            <span class="num-blue">{{ (scope.row.douyinIds || []).length }}</span>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="accountDouyinView = false">取消</el-button>
        <el-button type="primary" @click="confirmAccountDouyinFun">确定</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import {
  douyinAccountlist, globalAdConfigadd, globalAdConfigcheckAccounts, bookplatformList, librarylist, globalAdConfigpageWithTaskStats, globalAdConfigdetail, teamsharecheckAccounts, globalAdConfigaAwemeAuthList, projectvideoMatchresult, projectvideoMatchsubmit
} from '@/request/new/ylyBatch'
import { ElMessage, ElMessageBox } from 'element-plus'
import weektimeData from '@/components/weektime/weektime_data.js'
import { QuestionFilled } from '@element-plus/icons-vue'
import { reactive, toRefs, computed, nextTick, watch } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件
import insertViewBatchTrim from '@/components/batch/insertViewBatchTrim.vue'
import ylyOrganizationTree from '@/components/ylyBatch/ylyOrganizationTree.vue'
import ylySelectProducts from '@/components/ylyBatch/ylySelectProducts.vue'
import ylylinkCheck from '@/components/ylyBatch/ylylinkCheck.vue'
import ylyDouyingAccount from '@/components/ylyBatch/ylyDouyingAccount.vue' // 导入抖音号管理
import ylyBasicDataConifg from '@/components/ylyBatch/ylyBasicDataConifg.vue' // 导入基础数据
import ylySucaiSelector from '@/components/ylyBatch/ylySucaiSelector.vue' // 导入通用素材选择组件



export default {
  name: 'ylyProjectManage',
  components: { pagination, QuestionFilled, insertViewBatchTrim, ylyOrganizationTree, ylySelectProducts, ylylinkCheck, ylyDouyingAccount, ylyBasicDataConifg, ylySucaiSelector },
  setup() {
    const state = reactive({
      // // 模拟数据
      // requestParam: {},
      // 已选配置名称
      selectedStrategy: '',
      // 已选任务名称
      selectedTask: '',
      // ==========选择配置弹窗==========
      // 弹窗开关
      strategySelectView: false,
      // 配置名称搜索关键字
      strategySearchName: '',
      // 表格数据
      strategyTableData: [],
      // 表格loading
      strategyLoading: false,
      // 单选选中的行id
      selectedStrategyId: '',
      // 单选选中的行数据
      selectedStrategyRow: null,
      // 当前页
      strategyPage: 1,
      // 每页条数
      strategyPageSize: 20,
      // 总数
      strategyTotal: 0,
      // 组织账户弹窗控制
      orgAccountView: false,
      // 传入专辑链接的数据
      albumLinkParamData: {
        // 短剧平台
        platformCode: [],
        //变现模式
        monetizeMode: '',
      },
      // 营销产品弹窗控制
      marketingProductView: false,
      // 创意素材弹窗控制
      creativeMaterialView: false,
      // ==========自动匹配素材==========
      // 自动匹配轮询中
      autoMatchLoading: false,
      // 自动匹配状态提示
      autoMatchTip: '',
      // 自动匹配状态提示类型：info/success/danger
      autoMatchTipType: 'info',
      // 每个商品取素材库前 N 条组织素材进行匹配
      autoMatchMaxCount: 200,
      // 自动匹配数量弹窗控制
      autoMatchCountView: false,
      // 自动匹配轮询定时器
      autoMatchTimer: null,
      // 自动匹配轮询次数
      autoMatchPollCount: 0,

      // 抖音号分配：0=统一应用，1=分账户指定
      douyinSelectType: 1,
      // 分账户指定时：[{ accountId, douyinIds: [], douyinOptions: [], douyinNameMap: { [douyinId]: douyinName } }]
      accountDouyinMap: [],
      // 分账户指定弹窗
      accountDouyinView: false,
      // 按账户缓存的抖音号选项：{ accountId: [{label, value}] }，字段等你返回示例后可收紧
      awemeOptionsMap: {},
      awemeLoadingMap: {},
      douyinAccountView: false,
      // 基础信息弹窗
      baseInfoView: false,
      // 选择素材弹窗控制（通用组件 ylySucaiSelector，v-model）
      sucaiSelectView: false,
      // 当前操作的素材行（传给组件做回显 currentMaterialRow.sucai）
      currentMaterialRow: null,
      // 当前素材行索引
      currentMaterialIndex: null,
      // 专辑链接选项
      albumLinkOptions: [],
      // 专辑链接弹窗控制
      albumLinkView: false,
      albumLinkSelectedIds: [],
      selectedAlbumList: [],
      // 专辑链接弹窗关闭前暂存数据（等弹窗销毁后再渲染）
      pendingAlbumList: null,
      // 营销产品弹窗关闭前暂存数据（等弹窗销毁后再渲染）
      pendingMarketingList: null,
      // 工作台来源
      workbenchSource: 'new',

      // 营销产品选择================
      // 传入《☑选择营销产品》
      marketingProdu_product: {
        // 组织id
        accountId: '',
        // 商品库id
        productPlatformId: '',
        // 链接的剧名称
        productNames: [],
      },


      // 媒体账户弹窗控制
      mediaAccountView: false,
      // 创量项目名称
      chuangliangProject: '',
      // 项目生成规则
      projectRule: 'byDouyinXProduct',
      // 组织账户要传入的数据标识
      OrganizationTreeAge: '',

      // ====================请求参数===================================》
      config: {
        // 主键ID
        id: null,
        // 配置名称
        configName: '',
        // 短剧平台编码
        platformCode: '',
        // 短剧平台数据
        platformList: [],
        // 短剧平台名称
        platformName: '',
        // 已选媒体账户列表（展示名称用）
        mediaAccountList: [],
        //账户批量添加数据的desc
        accountIdsDesc: '',
        // 账户ID集合，数据库存JSON字符串，出入参均为数组
        accountIds: [],
        // 组织id
        orgAccountId: '',
        // 组织名称
        orgAccountName: '',
        // 素材选中的组织id
        sucaiorgAccountId: '',
        // 素材组织名称
        sucaiorgAccountName: '',
        // 产品名称
        productName: '',
        // 定向包 选择 0不传 1自定义
        directionalPackageType: 0,
        // 投放定向包ID
        directionalPackageId: '',
        // 投放定向包名称快照
        directionalPackageName: '',
        // 定向包数据
        directionalPackage: [],
        // 产品主图ID
        productMainImageId: '',
        // 产品主图名称快照
        productMainImageName: '',
        // 产品主图URL快照
        productMainImageUrl: '',
        // 产品主图数据
        productMainImageData: [],
        // 产品卖点
        sellingPoint: ['海量短剧免费看', '在线免费看全集', '海量漫剧等你来', '点击观看完整版'],
        // 行动号召
        callToAction: ['短剧免费看', '免费看全集'],
        // 自定义抖音号名称
        customDouyinName: '点击观看全集',
        // 标题库ID
        titlePackageId: '',
        // 标题库名称快照
        titlePackageName: '',
        // 标题库组数据
        titlePackageData: [],
        // AIGC动态素材:0关 1开
        aigcEnabled: 0,
        // 主页作品列表隐藏广告内容:0关 1开
        hideHomeAd: 0,
        // 变现模式:IAP / IAA_AND_IAP
        monetizeMode: 'IAA_AND_IAP',
        // 项目预算，单位：元
        budget: 300,
        // ROI系数，取值范围[0,5]
        uniRoiGoal: 1.200,
        // 投放时间类型:SCHEDULE_FROM_NOW / SCHEDULE_START_END
        scheduleType: 'SCHEDULE_FROM_NOW',
        // 投放起始时间，schedule_type=SCHEDULE_START_END时必填，如2017-01-01
        startTime: '',
        // 投放结束时间，schedule_type=SCHEDULE_START_END时必填，如2017-01-01
        endTime: '',
        // 每日投放时间，schedule_type=SCHEDULE_START_END时必填，如09:00
        scheduleTime: '',
        // 每日投放时间类型 0不限 指定时间段
        scheduleTimeType: 0,
        // 自定义投放时间段数据
        weektimeData: weektimeData,
        // 投放时段，7天×48半小时粒度勾选，参考 ToutiaoBatchPlanV2ServiceImpl 中 times -> schedule_time 48*7 位0/1串
        times: [],
        // 抖音号douyin_id数组，数据库存JSON字符串，出入参均为数组
        douyinIds: [],
        // 抖音号list数据
        douyinOptions: [],
        // 预打链接
        preCreateLink: '',
        // 定时发布时间
        timerTime: '',
        // 规则ID
        ruleId: null,
        // 规则名称快照
        ruleName: '',
        // 源数据ID
        sourceDataId: '',
        // 状态:1启用 0停用
        status: 1,
        // 创建人ID
        userId: null,
        // 创建人名称快照
        userName: '',
        // 创建时间
        createTime: '',
        // 更新时间
        updateTime: '',
        // 商品库id？？？？
        platformId: '',
        productLibraryOptions: [],
        // 基础信息是否已确认回传（用于控制241行回显展示）
        hasBaseInfo: false,
        // 前端请求参数原样JSON保存
        requestParam: {},
        // 营销产品
        selectedMarketingProductList: [],
        // 专属商品链接 赋值展示表格用
        linkCheckData: [],
        // 素材列表
        sucaiList: [],
        // 素材确定选中
        sucaiListCheck: false,
      },
      // 推广链接先用了===》营销产品再给他赋值，组织iD和商品库id还有看接口
      products: [],
      // 创意素材数组   提交接口的时候弄
      materials: [],
      //获取角色权限编号 
      rId: localStorage.getItem('rId'),
      //获取角色名称 
      loginUserName: localStorage.getItem('userName'),
      //接收组件的确定自定义账号数据
      getSonAccountListFun: (data) => {
        // 查看账号是否存在
        globalAdConfigcheckAccounts(data.dataList).then((res) => {
          if (res.code == 200) {
            // 管理员不走账户授权校验
            if (state.loginUserName == '黄彬' || state.loginUserName == '任文龙') {
              state.config.accountIds = data.dataList
              state.config.accountIdsDesc = data.desc
              state.config.mediaAccountList = res.data
              state.mediaAccountView = false
            } else {
              teamsharecheckAccounts({ accountIds: data.dataList }).then((res) => {
                if (res.code == 200) {
                  const noAuthList = (res.data || []).filter((item) => !item.allowed)
                  if (noAuthList.length > 0) {
                    const errMsg = noAuthList.map((item) => `组织名称：${item.teamName}<br/>账户名称：${item.accountName}<br/>账户id：${item.accountId}<br/>未授权请找组长授权`).join('<br/><br/>')
                    return ElMessage.error({ dangerouslyUseHTMLString: true, message: errMsg })
                  }
                  state.config.accountIds = data.dataList
                  state.config.accountIdsDesc = data.desc
                  state.config.mediaAccountList = res.data
                  state.mediaAccountView = false
                }
              })
            }
          }
        })
      },
      // 跳转商品管理
      jumpspglFun: () => {
        window.open('/spgl', '_blank')
      },
      //接收组件的确定选择组织
      getOrgData: (data) => {
        console.log('接收组件的确定选择组织', data)
        if (data.type == 'setSpType') {
          // 是在外面《商品与归属》,选择
          state.config.orgAccountId = data.id
          state.config.orgAccountName = data.name
          state.librarylistFun()
        }
        if (data.type == 'setSucaiType') {
          // 是在素材里面,选择
          state.config.sucaiorgAccountId = data.id
          state.config.sucaiorgAccountName = data.name
        }

        state.orgAccountView = false



      },
      // <商品与归属>在外面点击组织,查询商品库
      setSpTypeFun: () => {
        state.orgAccountView = true
        state.OrganizationTreeAge = 'setSpType'
      },
      // 在素材点击组织
      setsucaiTypeFun: () => {
        state.orgAccountView = true
        state.OrganizationTreeAge = 'setSucaiType'
      },

      // 接收组件选择推广链接
      linkCheckDataFun: (data) => {
        console.log('接收组件选择推广链接linkCheckDataFun', data)
        state.config.linkCheckData = data
        // 推广链接套了products
        state.products = data.map(item => ({
          readLinkType: item.readLinkType,
          dramaId: item.dramaId,
          dramaName: item.dramaName,
          playletSeriesUrlInfo: item.readLinkType === false ? state.productsSelectFun(item.readLinkType, item.playletSeriesUrlInfo) : [],
          promotionApplyInfo: item.readLinkType === false ? [] : state.productsSelectFun(item.readLinkType, item.playletSeriesUrlInfo),
          // 请求的链接list数据
          // playletSeriesUrlInfoData: item.playletSeriesUrlInfoData,
          // status: item.status,
          productName: '',
          productLibraryId: '',
          productId: '',
        }))

        console.log('接收组件选择推广链接取值之后的products', state.products)


        state.albumLinkView = false
      },
      // 接收组件推广链接识别取值的问题，根据readLinkType判断
      productsSelectFun: (readLinkType, data) => {
        if (readLinkType == true) {
          // 是预打链-promotionApplyInfo赋值对应的参数
          const list = data.map(item => ({
            playletSeriesUrlType: item.playletSeriesUrlType,
            distributorId: item.distributorId,
            purchasePanelTemplateId: item.panelTemplateId,
            promotionName: item.promotionName,
            remark: item.remark,
          }))
          return list
        } else {
          // 不是预打链 -playletSeriesUrlInfo 赋值对应的参数
          const list = data.map(item => ({
            playletSeriesUrlType: item.playletSeriesUrlType,
            playletSeriesUrl: item.promotionUrl,
          }))
          return list
        }
      },
      // 查询商品库
      librarylistFun: () => {
        if (state.config.orgAccountName == '') {
          ElMessage.error('请先选择组织')
        } else {
          const datas = {
            accountId: state.config.orgAccountId,
            currenPage: 1,
            size: 1000,
          }
          librarylist(datas).then((res) => {
            state.config.productLibraryOptions = res.data.data
            if (res.data.data.length == 0) {
              ElMessage.error('商品库为空！！！请排查，1、检查组织是否有商品库。')
            }
          })
        }
      },
      // 营销产品组件内选中的商品
      SPproductData: (data) => {
        console.log('组件内选中的商品config.selectedMarketingProductList', data)
        // 现在产品先不选择，等到提交的时候再去赋值判断
        state.marketingProductView = false
        state.config.selectedMarketingProductList = data

      },
      // 点击选中营销按钮
      openYXCPFun: () => {
        if (state.config.platformId == '') {
          ElMessage.error('请先选择商品库')
        } else {
          state.marketingProductView = true
          state.marketingProdu_product.accountId = state.config.orgAccountId
          state.marketingProdu_product.productPlatformId = state.config.platformId

          if (state.products.length > 0) {
            console.log('链接有数据state.products', state.products)
            // 赋值链接的剧名名称
            state.marketingProdu_product.productNames = state.products.map((item) => item.dramaName)
          }
          console.log('点击选中营销按钮', state.marketingProdu_product)
        }
      },
      // 赋值
      fuzhiFun: () => {
        console.log('赋值fuzhiFun', state.requestParam)
        state.config = JSON.parse(JSON.stringify(state.requestParam.config))
        state.products = JSON.parse(JSON.stringify(state.requestParam.products))
        // state.materials = JSON.parse(JSON.stringify(state.requestParam.materials))
        // 给素材赋值
        // state.sucaiList = JSON.parse(JSON.stringify(state.requestParam.config.sucaiList))
      },
      // 选择专辑链接按钮
      albumLinkViewFun: () => {
        if (state.config.platformCode != '') {
          state.albumLinkParamData.platformCode = state.config.platformCode
          state.albumLinkParamData.monetizeMode = state.config.monetizeMode
          state.albumLinkView = true
        } else {
          ElMessage.error('请先选择短剧平台')
        }
      },
      // 接收基础配置数据
      receiveConfigFun: (data) => {
        console.log('接收基础配置数据receiveConfigFun', data)
        state.config = JSON.parse(JSON.stringify(data))
        state.config.hasBaseInfo = true
        state.baseInfoView = false
      },
      // 确定提交请求配置
      globalAdConfigaddFun: async () => {
        // 分账户指定模式：逐账户校验；统一应用模式走下方老逻辑，保持不变
        if (state.douyinSelectType === 1) {
          if (state.config.accountIds.length == 0) {
            return ElMessage.error('账户不能为空，请选择账户')
          }
          const emptyAcc = state.accountDouyinMap.filter(
            (row) => !(row.douyinIds && row.douyinIds.length > 0)
          )
          if (emptyAcc.length > 0) {
            return ElMessage.error('分账户指定模式下，每个媒体账户都必须指定至少一个抖音号')
          }
          // 统一模式字段兼容：把各账户抖音号去重合并，后端仍可用 douyinIds 校验
          state.config.douyinIds = [...new Set(state.accountDouyinMap.flatMap((row) => row.douyinIds || []))]
        }
        if (state.config.accountIds.length == 0) {
          return ElMessage.error('账户不能为空，请选择账户')
        }
        if (state.config.douyinIds.length == 0) {
          return ElMessage.error('抖音号不能为空，请选择抖音号')
        }
        if (state.config.selectedMarketingProductList.length == 0) {
          return ElMessage.error('营销产品不能为空，请选择营销产品')
        }
        // 配置信息检查
        if (state.config.configName == '') {
          return ElMessage.error('配置名称不能为空')
        }
        if (state.config.hasBaseInfo == false) {
          return ElMessage.error('请选择基础信息')
        }


        // 链接和营销产品赋值
        if (state.products.length == state.config.selectedMarketingProductList.length) {
          state.products.forEach((item) => {
            // 在选中列表里找到 dramaName 和 productName 相等的那一项
            const matchItem = state.config.selectedMarketingProductList.find(
              (selected) => selected.productName === item.dramaName
            )
            // 找到匹配才赋值
            if (matchItem) {
              item.productId = matchItem.productId
              item.productName = matchItem.productName
              item.productLibraryId = matchItem.productLibraryId
            } else {
              // 未找到匹配，抛出提示
              ElMessage.error(`未找到【${item.dramaName}】对应的营销产品数据`)
            }
          })



        } else {
          return ElMessage.error('专辑链接有' + state.products.length + '个和营销产品' + state.config.selectedMarketingProductList.length + '个，数量有差异')
        }

        if (state.materials.length == 0) {
          return ElMessage.error('创意素材不能为空,请选择素材...')
        }
        // 逐行校验：每个营销产品都必须选中素材（不只依赖 sucaiListCheck 标记，防止复用配置绕过）
        const unselectedRow = state.materials.find((row) => !(row.sucai && row.sucai.length > 0))
        if (unselectedRow) {
          return ElMessage.error(`【${unselectedRow.productName || '营销产品'}】未选择素材，请先配置创意素材`)
        }
        if (state.config.sucaiListCheck == false) {
          return ElMessage.error('创意素材不能为空,请选择素材.')
        }

        // 素材赋值
        const materialsNewArr = state.materials.flatMap(item => {
          return item.sucai.map(bItem => ({
            productId: item.productId,
            productName: item.productName,
            productLibraryId: state.config.platformId,
            imageMode: bItem.imageMode,
            videoId: bItem.videoId,
            materialType: bItem.materialType,
            materialId: bItem.materialId,
            materialName: bItem.materialName,
            materialUrl: bItem.posterUrl
            // c: bItem.c,
          }))
        })
        // 时间赋值
        if (state.config.scheduleTimeType == 1) {
          state.config.times = state.config.weektimeData
        } else {
          state.config.times = []
        }
        // 抖音号分配模式随请求保存；统一应用模式保持之前一样不变，不提交分账户数据
        state.config.douyinSelectType = state.douyinSelectType
        if (state.douyinSelectType === 1) {
          state.accountDouyinMap.forEach((row) => syncRowDouyinNameMap(row.accountId))
        }
        state.config.accountDouyinMap = state.douyinSelectType === 1 ? JSON.parse(JSON.stringify(state.accountDouyinMap)) : []
        // 给素材数据保留
        state.config.sucaiList = state.sucaiList
        // 确定创建
        state.config.requestParam = []
        const requestParamData = {
          config: JSON.parse(JSON.stringify(state.config)),
          products: JSON.parse(JSON.stringify(state.products)),
        }
        state.config.requestParam = JSON.stringify(requestParamData)
        const datas = {
          config: state.config,
          products: state.products,
          materials: materialsNewArr,
        }
        console.log('确定创建赋值', datas)
        globalAdConfigadd(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success(res.msg)
          }
        })

      },
    })

    // 已选媒体账户名称拼接（用于省略展示）
    const mediaAccountNames = computed(() => {
      return state.config.mediaAccountList.map((item) => item.name || item.accountName || item.douyinName || item.id).join('、')
    })

    // ==========基础信息回显：定向包名称（不限/自定义名称）==========
    const configDirectionalPackageText = computed(() => {
      if (Number(state.config.directionalPackageType) !== 1) return '不限'
      return state.config.directionalPackageName || '未选择'
    })

    // ==========基础信息回显：投放时间（长期投放/开始时间-结束时间）==========
    const configScheduleText = computed(() => {
      if (state.config.scheduleType === 'SCHEDULE_START_END') {
        if (state.config.startTime && state.config.endTime) {
          return `${state.config.startTime} ~ ${state.config.endTime}`
        }
        return '设置开始和结束日期（未完整）'
      }
      return '长期投放'
    })

    const removeMarketingProduct = (id) => {
      state.config.selectedMarketingProductList = state.config.selectedMarketingProductList.filter((item) => item.productId !== id)
    }

    const clearMarketingProducts = () => {
      state.config.selectedMarketingProductList = []
    }

    // ==========监听营销产品变化，增量同步 materials==========
    watch(
      () => state.config.selectedMarketingProductList,
      (list) => {
        // 移除已取消选择的营销产品对应行
        state.materials = state.materials.filter((row) =>
          list.some((item) => item.productId === row.productId)
        )
        // 新增的营销产品追加到 materials 末尾
        list.forEach((item) => {
          const exists = state.materials.some((row) => row.productId === item.productId)
          if (!exists) {
            state.materials.push({
              productId: item.productId,
              productName: item.productName,
              status: false,
              sucai: [],

            })
          }
        })
      },
      { deep: true }
    )

    // ==========选择专辑链接==========
    const toggleAlbumLink = (item) => {
      const index = state.albumLinkSelectedIds.indexOf(item.id)
      if (index > -1) {
        state.albumLinkSelectedIds.splice(index, 1)
      } else {
        state.albumLinkSelectedIds.push(item.id)
      }
    }



    const removeproducts = (id) => {
      state.products = state.products.filter((item) => item.dramaId !== id)
      state.config.linkCheckData = (state.config.linkCheckData || []).filter((item) => item.dramaId !== id)
    }

    const clearproductss = () => {
      state.products = []
      state.config.linkCheckData = []
    }

    // ==========选择配置==========
    const selectStrategyFun = () => {
      state.strategySelectView = true
      state.strategyPage = 1
      state.selectedStrategyId = ''
      state.selectedStrategyRow = null
      globalAdConfigpageWithTaskStatsFun()
    }

    // ==========选择配置弹窗：分页查询（带任务详情统计），配置名称模糊查询==========
    const globalAdConfigpageWithTaskStatsFun = () => {
      state.strategyLoading = true
      const datas = {
        currenPage: state.strategyPage,
        size: state.strategyPageSize,
        configName: state.strategySearchName || null,
      }
      globalAdConfigpageWithTaskStats(datas).then((res) => {
        const payload = res && res.data !== undefined ? res.data : res
        state.strategyPage = payload.currenPage ?? payload.currentPage ?? state.strategyPage
        state.strategyTotal = payload.totalSize ?? payload.total ?? 0
        const list = payload.data ?? payload.list ?? payload.records ?? []
        state.strategyTableData = Array.isArray(list) ? list : []
      }).catch(() => {
        ElMessage.error('配置列表加载失败')
      }).finally(() => {
        state.strategyLoading = false
      })
    }

    // ==========选择配置弹窗：查询按钮（搜索配置名称）==========
    const strategySearchFun = () => {
      state.strategyPage = 1
      globalAdConfigpageWithTaskStatsFun()
    }

    // ==========选择配置弹窗：单选行改变==========
    const handleStrategyCurrentChange = (row) => {
      if (!row) return
      state.selectedStrategyId = row.configId ?? row.id
      state.selectedStrategyRow = row
    }

    // ==========选择配置弹窗：页码改变==========
    const strategyHandleCurrentChange = (e) => {
      state.strategyPage = e
      globalAdConfigpageWithTaskStatsFun()
    }

    // ==========选择配置弹窗：每页条数改变==========
    const strategyHandleSizeChange = (e) => {
      state.strategyPageSize = e
      state.strategyPage = 1
      globalAdConfigpageWithTaskStatsFun()
    }

    // ==========选择配置弹窗：确定按钮，查询详情后关闭弹窗并把详情数据传给关闭方法==========
    const confirmStrategySelectFun = async () => {
      if (!state.selectedStrategyRow) {
        ElMessage.warning('请先选择一条配置')
        return
      }


      globalAdConfigdetail({ id: state.selectedStrategyId }).then((res) => {
        console.log('globalAdConfigdetail', res)
        if (res.code == 200) {
          const requestParam = JSON.parse(res.data.config.requestParam)
          console.log('requestParam', requestParam)
          state.config = JSON.parse(JSON.stringify(requestParam.config))
          state.products = JSON.parse(JSON.stringify(requestParam.products))
          // state.config = requestParam.config
          // state.materials = requestParam.materials
          // state.products = requestParam.products
          state.config.configName = state.config.configName + '复用'
          state.strategySelectView = false
          // 复用配置必须重选素材：按当前营销产品重建 materials 空行，强制走校验
          state.materials = (state.config.selectedMarketingProductList || []).map((item) => ({
            productId: item.productId,
            productName: item.productName,
            status: false,
            sucai: [],
          }))
          // 素材效验
          state.config.sucaiListCheck = false
          // 还原抖音号分配模式（老数据默认统一应用）
          state.douyinSelectType = Number(state.config.douyinSelectType) === 1 ? 1 : 0
          state.accountDouyinMap = (Array.isArray(state.config.accountDouyinMap) ? JSON.parse(JSON.stringify(state.config.accountDouyinMap)) : []).map((row) => ({
            ...row,
            douyinIds: Array.isArray(row.douyinIds) ? row.douyinIds : [],
            douyinOptions: Array.isArray(row.douyinOptions) ? row.douyinOptions : [],
            douyinNameMap: row.douyinNameMap && typeof row.douyinNameMap === 'object' && !Array.isArray(row.douyinNameMap) ? row.douyinNameMap : {},
          }))
          // 等待后端传入
        }
      })

    }



    // ==========选择任务==========
    const selectTaskFun = () => {
      // 打开任务选择弹窗，等待接口/组件
      console.log('打开选择任务弹窗')
    }

    // ==========选择创量项目==========
    const selectChuangliangProjectFun = () => {
      // 打开创量项目选择弹窗，等待接口/组件
      console.log('打开选择创量项目弹窗')
    }

    // ==========选择创意素材==========
    const openCreativeMaterialFun = () => {
      if (state.config.selectedMarketingProductList.length === 0) {
        ElMessage.error('请先选择营销产品')
      } else {
        // 如果素材的组织为空，且商品库组织不为空才赋值
        if (state.config.orgAccountId != '' && state.config.sucaiorgAccountId == '') {
          state.config.sucaiorgAccountId = JSON.parse(JSON.stringify(state.config.orgAccountId))
          state.config.sucaiorgAccountName = JSON.parse(JSON.stringify(state.config.orgAccountName))

        }
        // 按当前营销产品对齐 materials：移除多余行、新增行补空行（复用配置后营销产品变化也能同步）
        const list = state.config.selectedMarketingProductList
        state.materials = list.map((item) => {
          const existing = state.materials.find((row) => row.productId === item.productId)
          return existing || {
            productId: item.productId,
            productName: item.productName,
            status: false,
            sucai: [],
          }
        })
        state.creativeMaterialView = true
      }

    }

    // ==========选择素材（打开通用素材选择弹窗，查询/选中逻辑在组件 ylySucaiSelector 内部）==========
    const openSucaiSelectFun = (scope) => {
      // 因为是默认账户维度去查素材，并且默认是第一个账户
      if (state.config.accountIds.length == 0) {
        return ElMessage.error('请先填写账户')
      }
      state.currentMaterialRow = scope.row
      state.currentMaterialIndex = scope.$index
      state.sucaiSelectView = true
    }

    // ==========通用素材组件确定回填：把组件返回的归一化数组写回对应行==========
    const handleSucaiConfirmFun = (list) => {
      const row = state.currentMaterialRow
      if (row) {
        row.sucai = list || []
        row.status = row.sucai.length > 0
      }
      state.sucaiSelectView = false
    }

    // ==========创意素材统计（外层弹窗/主表单展示用）==========
    const materialGroupCount = computed(() => state.materials.length)
    const materialTotalCount = computed(() => state.materials.reduce((sum, row) => sum + (row.sucai ? row.sucai.length : 0), 0))

    // ==========清空素材确认==========
    const clearSucaiConfirmFun = (scope) => {
      const row = scope.row
      if (row.sucai.length === 0) {
        ElMessage.warning('该商品暂无已选素材')
        return
      }
      ElMessageBox.confirm('是否删除选中的素材？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        row.sucai = []
        row.status = false
        ElMessage.success('已清空素材')
      }).catch(() => { })
    }

    // ==========确认创意素材==========
    const confirmCreativeMaterialFun = () => {
      // 校验是否所有行都选中了素材
      const allSelected = state.materials.every((row) => row.sucai && row.sucai.length > 0)
      if (!allSelected) {
        ElMessage.error('素材未选中，请选中素材')
        return
      }
      state.creativeMaterialView = false
      state.config.sucaiListCheck = true
      console.log('确认创意素材state.materials', state.materials)
    }

    // ==========自动匹配素材==========
    // 打开匹配数量弹窗
    const openAutoMatchCountDialog = () => {
      if (state.autoMatchLoading) return
      if (state.config.accountIds.length === 0) {
        return ElMessage.error('请先填写账户')
      }
      if (state.materials.length === 0) {
        return ElMessage.error('暂无营销产品，请先选择营销产品')
      }
      state.autoMatchCountView = true
    }

    // 确定匹配：校验数量后关闭弹窗并提交匹配任务
    const confirmAutoMatchCountFun = () => {
      const count = Number(state.autoMatchMaxCount)
      if (!count || count < 1 || count > 200) {
        return ElMessage({ type: 'warning', message: '素材匹配数量需为1~200之间的整数' })
      }
      state.autoMatchMaxCount = Math.floor(count)
      state.autoMatchCountView = false
      autoMatchVideosFun()
    }

    // 组装提交参数：与手动选择素材一致，按账户维度匹配（取第一个媒体账户），每项 = { advertiserId, materialName: 商品名称, maxCount }
    const buildAutoMatchParams = () => {
      const advertiserId = state.config.accountIds && state.config.accountIds.length > 0 ? Number(state.config.accountIds[0]) : ''
      return (state.materials || [])
        .filter((row) => advertiserId && row.productName)
        .map((row) => ({
          advertiserId,
          materialName: row.productName,
          maxCount: state.autoMatchMaxCount,
        }))
    }

    // 归一化匹配结果中的单个素材：字段与 ylySucaiSelector 输出保持一致（提交接口依赖 materialType/imageMode/videoId 等）
    const normalizeMatchVideo = (item) => {
      let imageMode = item.imageMode ?? item.image_mode ?? null
      if (!imageMode && item.width && item.height) {
        imageMode = Number(item.width) > Number(item.height) ? 'CREATIVE_IMAGE_MODE_VIDEO' : 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
      }
      return {
        materialId: item.materialId ?? item.material_id ?? '',
        materialName: item.materialName ?? item.material_name ?? item.fileName ?? item.file_name ?? '',
        posterUrl: item.posterUrl ?? item.poster_url ?? '',
        url: item.url ?? '',
        videoId: item.videoId ?? item.video_id ?? '',
        materialType: item.materialType ?? item.material_type ?? item.format ?? 'MP4',
        duration: item.duration ?? '',
        imageMode,
      }
    }

    // 停止轮询
    const stopAutoMatchPolling = () => {
      if (state.autoMatchTimer) {
        clearInterval(state.autoMatchTimer)
        state.autoMatchTimer = null
      }
    }

    // 点击自动匹配素材：提交匹配任务并开始轮询
    const autoMatchVideosFun = async () => {
      if (state.autoMatchLoading) return
      const params = buildAutoMatchParams()
      if (params.length === 0) {
        return ElMessage({ type: 'warning', message: '暂无可匹配的商品数据' })
      }
      state.autoMatchLoading = true
      state.autoMatchTipType = 'info'
      state.autoMatchTip = '正在提交匹配任务...'
      try {
        const res = await projectvideoMatchsubmit(params)
        if (res.code == 200) {
          const taskId = res.data?.taskId
          if (!taskId) {
            state.autoMatchLoading = false
            state.autoMatchTipType = 'danger'
            state.autoMatchTip = '匹配任务提交成功，但未获取到taskId'
            return ElMessage.error('匹配任务提交成功，但未获取到taskId')
          }
          state.autoMatchTipType = 'info'
          state.autoMatchTip = '匹配任务已提交，正在等待匹配结果...'
          startAutoMatchPolling(taskId)
        } else {
          state.autoMatchLoading = false
          state.autoMatchTipType = 'danger'
          state.autoMatchTip = res.msg || '提交匹配任务失败'
          ElMessage.error(res.msg || '提交匹配任务失败')
        }
      } catch (e) {
        state.autoMatchLoading = false
        state.autoMatchTipType = 'danger'
        state.autoMatchTip = '提交匹配任务失败'
      }
    }

    // 轮询匹配结果：2秒一次，最多60次（约2分钟）；result返回500立即停止轮询
    const startAutoMatchPolling = (taskId) => {
      stopAutoMatchPolling()
      state.autoMatchPollCount = 0
      const MAX_POLL = 60
      const INTERVAL = 2000
      state.autoMatchTimer = setInterval(async () => {
        state.autoMatchPollCount += 1
        if (state.autoMatchPollCount > MAX_POLL) {
          stopAutoMatchPolling()
          state.autoMatchLoading = false
          state.autoMatchTipType = 'danger'
          state.autoMatchTip = '匹配超时，请稍后重试或手动选择素材'
          ElMessage.warning('自动匹配超时，请稍后重试')
          return
        }
        try {
          const res = await projectvideoMatchresult({ taskId })
          // 返回500：任务不存在或已失效，停止轮询
          if (res.code == 500) {
            stopAutoMatchPolling()
            state.autoMatchLoading = false
            state.autoMatchTipType = 'danger'
            state.autoMatchTip = res.msg || '匹配结果查询失败，已停止轮询'
            ElMessage.error(res.msg || '匹配结果查询失败，已停止轮询')
            return
          }
          if (res.code == 200) {
            const data = res.data || {}
            const items = data.items || []
            const status = data.status
            // status 为 RUNNING 继续轮询，其他状态（SUCCESS/FAIL等）终止
            if (status === 'RUNNING') {
              state.autoMatchTipType = 'info'
              state.autoMatchTip = `匹配中...（成功${data.successCount ?? 0}，失败${data.failCount ?? 0}，进行中${data.runningCount ?? 0}）`
              return
            }
            if (status) {
              applyAutoMatchResult(items)
              stopAutoMatchPolling()
              state.autoMatchLoading = false
              const successCount = data.successCount ?? items.filter((it) => it.status === 'SUCCESS').length
              const failCount = data.failCount ?? 0
              const totalVideo = items.reduce((sum, it) => sum + (it.videoCount || 0), 0)
              state.autoMatchTipType = failCount > 0 ? 'danger' : 'success'
              state.autoMatchTip = failCount > 0 ? `匹配完成：成功${successCount}个，失败${failCount}个` : '自动匹配完成'
              if (failCount > 0) {
                ElMessage.warning(`匹配完成：成功${successCount}个，失败${failCount}个，共匹配${totalVideo}个素材`)
              } else {
                ElMessage.success(`自动匹配完成，共匹配${totalVideo}个素材`)
              }
            }
          }
        } catch (e) {
          // 单次轮询失败不中断，等下一次
        }
      }, INTERVAL)
    }

    // 回填匹配结果：按商品名称匹配 materials 行，去重后追加到 sucai（保留手动已选素材）
    const applyAutoMatchResult = (items) => {
      items.forEach((row) => {
        const materialName = row.materialName ?? row.material_name
        const videos = (row.videos || []).map(normalizeMatchVideo)
        const target = (state.materials || []).find((item) => item.productName === materialName)
        if (target && videos.length > 0) {
          const existIds = new Set((target.sucai || []).map((v) => v.materialId))
          const appendList = videos.filter((v) => !existIds.has(v.materialId))
          target.sucai = [...(target.sucai || []), ...appendList]
          target.status = target.sucai.length > 0
        }
      })
    }

    // 选择创意素材弹窗关闭时停止自动匹配轮询，避免后台空转
    watch(
      () => state.creativeMaterialView,
      (val) => {
        if (!val) {
          stopAutoMatchPolling()
          state.autoMatchLoading = false
          state.autoMatchTip = ''
          state.autoMatchTipType = 'info'
          state.autoMatchCountView = false
        }
      }
    )

    // ==========确认媒体账户==========
    const confirmMediaAccount = () => {
      state.mediaAccountView = false
      ElMessage.success('媒体账户已更新')
    }


    //分销平台下拉框（查询所有启用的平台）
    const bookplatformListFun = () => {
      bookplatformList().then((res) => {
        state.config.platformList = res.data
      })
    }

    // 抖音号列表（点击选择器时触发，收起时不请求）
    const douyinAccountlistFun = () => {
      const datas = {
        currentPage: 1,
        size: 200,
      }
      douyinAccountlist(datas).then((res) => {
        if (res.code == 200) {
          state.config.douyinOptions = res.data.data || []
        } else {
          ElMessage.error(res.msg)
        }
      })
    }

    const fetchAllAwemeAuthList = async (advertiserId) => {
      const pageSize = 100
      const firstRes = await globalAdConfigaAwemeAuthList({ advertiserId, page: 1, pageSize })
      const firstData = firstRes && firstRes.data ? firstRes.data : {}
      const firstList = Array.isArray(firstData.list) ? firstData.list : []
      const totalPage = Number(firstData.page_info && firstData.page_info.total_page) || 1
      if (firstRes.code !== 200) throw new Error(firstRes.msg || '抖音号授权列表加载失败')
      if (totalPage <= 1) return firstList

      const pageResults = await Promise.all(
        Array.from({ length: totalPage - 1 }, (_, index) =>
          globalAdConfigaAwemeAuthList({ advertiserId, page: index + 2, pageSize })
        )
      )
      return firstList.concat(...pageResults.map((res) => {
        if (!res || res.code !== 200) throw new Error((res && res.msg) || '抖音号授权列表加载失败')
        return res.data && Array.isArray(res.data.list) ? res.data.list : []
      }))
    }

    const onDouyinVisibleChange = (visible) => {
      if (!visible) return
      const firstAccountId = state.config.accountIds && state.config.accountIds.length > 0 ? state.config.accountIds[0] : null
      if (!firstAccountId) {
        return ElMessage.error('请先在顶部选择媒体账户')
      }
      fetchAllAwemeAuthList(firstAccountId).then((list) => {
        state.config.douyinOptions = list.map((item) => ({
          douyinId: item.aweme_id,
          douyinName: item.aweme_name,
        }))
      }).catch(() => {
        ElMessage.error('抖音号授权列表加载失败')
      })
    }

    const getAccountKey = (acc) => String(acc.accountId ?? acc.id ?? acc.douyinId ?? '')
    const getAccountName = (acc) => acc.name || acc.accountName || acc.douyinName || (`账户 ${getAccountKey(acc)}`)

    // 分账户行操作（accountDouyinMap 为 [{accountId, douyinIds, douyinOptions, douyinNameMap}]）
    const getRowByAccountId = (accountId) =>
      state.accountDouyinMap.find((row) => String(row.accountId) === String(accountId))
    const getAccountNameById = (accountId) => {
      const acc = (state.config.mediaAccountList || []).find((item) => String(getAccountKey(item)) === String(accountId))
      return acc ? getAccountName(acc) : `账户 ${accountId}`
    }
    // 按当前选中 douyinIds 重建 douyinNameMap：{ [douyinId]: douyinName }
    const syncRowDouyinNameMap = (accountId) => {
      const row = getRowByAccountId(accountId)
      if (!row) return
      const opts = state.awemeOptionsMap[accountId] || row.douyinOptions || []
      const nameByValue = {}
      opts.forEach((item) => { nameByValue[item.value] = item.label })
      const oldNameByValue = Object.assign({}, row.douyinNameMap || {})
      const nameMap = {}
      ;(row.douyinIds || []).forEach((id) => {
        const name = nameByValue[id] != null ? nameByValue[id] : oldNameByValue[id]
        if (name != null) nameMap[id] = name
      })
      row.douyinNameMap = nameMap
    }
    const onAccountDouyinChange = (accountId, val) => {
      const row = getRowByAccountId(accountId)
      if (row) {
        row.douyinIds = val || []
        syncRowDouyinNameMap(accountId)
      }
    }

    // 打开分账户指定弹窗（先选中账户）
    const openAccountDouyinFun = () => {
      if (state.config.accountIds.length === 0) {
        return ElMessage.error('请先在顶部选择媒体账户')
      }
      state.accountDouyinMap.forEach((row) => {
        if (!row || !row.accountId) return
        if (row.douyinOptions && row.douyinOptions.length) {
          if (!state.awemeOptionsMap[row.accountId] || !state.awemeOptionsMap[row.accountId].length) {
            state.awemeOptionsMap[row.accountId] = JSON.parse(JSON.stringify(row.douyinOptions))
          }
        }
        syncRowDouyinNameMap(row.accountId)
      })
      state.accountDouyinView = true
    }

    // 清空所有账户已选抖音号
    const clearAccountDouyinFun = () => {
      ElMessageBox.confirm('是否清空所有账户已配置的抖音号？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        state.accountDouyinMap.forEach((row) => {
          row.douyinIds = []
          row.douyinNameMap = {}
        })
        ElMessage.success('已清空')
      }).catch(() => { })
    }

    // 拉取某个账户的抖音授权列表
    const loadAwemeOptions = (accountId) => {
      state.awemeLoadingMap[accountId] = true
      fetchAllAwemeAuthList(accountId).then((list) => {
        state.awemeOptionsMap[accountId] = list.map((item) => ({
          label: item.aweme_name,
          value: item.aweme_id,
        }))
      }).catch(() => {
        ElMessage.error('抖音号授权列表加载失败')
      }).finally(() => {
        syncRowOptions(accountId); state.awemeLoadingMap[accountId] = false
      })
    }

    // 弹窗内点击第二列选择器展开时，按当前行账户id请求
    const syncRowOptions = (accountId) => { const opts=state.awemeOptionsMap[accountId]||[]; const row=(state.accountDouyinMap||[]).find((r)=>String(r.accountId)===String(accountId)); if(row){ row.douyinOptions=JSON.parse(JSON.stringify(opts)); syncRowDouyinNameMap(accountId) } }; const onAwemeVisibleChange = (visible, row) => {
      if (!visible) return
      loadAwemeOptions(row.accountId)
    }

    // 分账户弹窗确定
    const confirmAccountDouyinFun = () => {
      state.accountDouyinView = false
    }

    // 已配置账户数（有抖音号的账户）
    const configuredAccountCount = computed(
      () => state.accountDouyinMap.filter((row) => row.douyinIds && row.douyinIds.length > 0).length
    )

    // 已选抖音号总数（统一模式取 douyinIds，分账户模式取各账户去重合并）
    const douyinTotalCount = computed(() => {
      if (state.douyinSelectType === 1) {
        return new Set(state.accountDouyinMap.flatMap((row) => row.douyinIds || [])).size
      }
      return (state.config.douyinIds || []).length
    })
    const isDouyinDone = computed(() => douyinTotalCount.value > 0)

    // 媒体账户变化时同步 accountDouyinMap：新增追加空行，删除的清理掉
    watch(
      () => state.config.accountIds,
      (ids) => {
        const list = (ids || []).map((id) => {
          const existing = state.accountDouyinMap.find((row) => String(row.accountId) === String(id))
          return {
            accountId: id,
            douyinIds: existing ? existing.douyinIds : [],
            douyinOptions: existing && existing.douyinOptions ? existing.douyinOptions : [],
            douyinNameMap: existing && existing.douyinNameMap ? existing.douyinNameMap : {},
          }
        })
        state.accountDouyinMap = list
      },
      { deep: true }
    )





    bookplatformListFun()

    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      mediaAccountNames,
      configDirectionalPackageText,
      configScheduleText,
      removeMarketingProduct,
      clearMarketingProducts,
      toggleAlbumLink,
      clearproductss,
      removeproducts,
      selectStrategyFun,
      globalAdConfigpageWithTaskStatsFun,
      strategySearchFun,
      handleStrategyCurrentChange,
      strategyHandleCurrentChange,
      strategyHandleSizeChange,
      confirmStrategySelectFun,
      selectTaskFun,
      selectChuangliangProjectFun,
      openCreativeMaterialFun,
      openSucaiSelectFun,
      handleSucaiConfirmFun,
      materialGroupCount,
      materialTotalCount,
      clearSucaiConfirmFun,
      confirmCreativeMaterialFun,
      openAutoMatchCountDialog,
      confirmAutoMatchCountFun,
      confirmMediaAccount,
      bookplatformListFun,
      douyinAccountlistFun,
      onDouyinVisibleChange,
      getAccountKey,
      getAccountName,
      getAccountNameById,
      onAccountDouyinChange,
      openAccountDouyinFun,
      clearAccountDouyinFun,
      onAwemeVisibleChange,
      confirmAccountDouyinFun,
      configuredAccountCount,
      douyinTotalCount,
      isDouyinDone
    }
  },
}
</script>

<style lang="scss" scoped>
.tool-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

/* 已选信息 */
.selected-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 60%;
  font-size: 13px;
  color: #606266;
}

.selected-label {
  flex-shrink: 0;
  color: #303133;
}

.selected-text {
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: bottom;
  color: #303133;
}

.selected-close {
  flex-shrink: 0;
  color: #c0c4cc;
  cursor: pointer;
  font-size: 14px;
}

/* 分组容器 */
.group-box {
  display: inline-flex;
  align-items: stretch;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  min-width: 260px;
  max-width: 420px;
}

.group-label {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 12px;
  flex-shrink: 0;
  background: #f5f7fa;
  color: #606266;
  font-size: 13px;
  white-space: nowrap;
}

.help-icon {
  color: #c0c4cc;
  cursor: help;
}

.group-content {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  min-width: 0;
}

.group-text {
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #303133;
}

.group-count {
  flex-shrink: 0;
  font-size: 12px;
  color: #909399;
}

.group-placeholder {
  font-size: 13px;
  color: #909399;
  white-space: nowrap;
}

.section-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;

  :deep(.el-card__header) {
    padding: 14px 16px;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
  }

  :deep(.el-card__body) {
    padding: 16px;
  }
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.section-title-wrap {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.section-subtitle {
  font-size: 12px;
  color: #909399;
  font-weight: 400;

  .req {
    color: #f56c6c;
    font-style: normal;
  }
}

.section-steps-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #909399;
}

.hint-dot {
  color: #dcdfe6;
}

.section-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ===== 投放内容步骤卡片 ===== */
.content-card {
  :deep(.el-card__body) {
    padding: 16px;
    background: #f6f8fb;
  }
}

.content-step {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 16px;
}

.step-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px dashed #ebeef5;
}

.step-num {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #409eff, #66b1ff);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
}

.step-text {
  flex: 1;
  min-width: 0;
}

.step-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 8px;
}

.step-tag {
  font-size: 11px;
  font-weight: 400;
  color: #409eff;
  background: #ecf5ff;
  border-radius: 4px;
  padding: 1px 6px;
}

.step-desc {
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
}

.step-state {
  flex-shrink: 0;
  font-size: 12px;
  color: #e6a23c;
  background: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 12px;
  padding: 2px 10px;

  &.done {
    color: #67c23a;
    background: #f0f9eb;
    border-color: #e1f3d8;
  }
}

.step-grid {
  display: grid;
  gap: 12px;
  margin-bottom: 12px;

  &.grid-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1100px) {
  .step-grid.grid-2 {
    grid-template-columns: 1fr;
  }
}

.field-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px 14px;
  background: #fff;

  &.is-full {
    margin-bottom: 12px;
  }

  &.slim {
    margin-bottom: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.field-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.field-card-label {
  font-size: 14px;
  font-weight: 600;
  color: #303133;

  .req {
    color: #f56c6c;
    font-style: normal;
  }
}

.field-card-tip {
  font-size: 12px;
  color: #909399;
}

.head-spacer {
  flex: 1;
}

.select-full {
  width: 100%;
}

.inline-count {
  margin-top: 6px;
  font-size: 12px;
  color: #409eff;
}

.empty-hint {
  font-size: 12px;
  color: #909399;
  background: #f5f7fa;
  border-radius: 6px;
  padding: 10px 12px;
}

.empty-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 22px 12px;
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  background: #fafcff;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: #409eff;
    background: #f0f7ff;
  }
}

.empty-icon {
  width: 28px;
  height: 28px;
  line-height: 26px;
  text-align: center;
  border-radius: 50%;
  background: #ecf5ff;
  color: #409eff;
  font-size: 18px;
}

.empty-text {
  font-size: 13px;
  color: #606266;
}

.empty-sub {
  font-size: 12px;
  color: #909399;
}

.album-index {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  background: #ecf5ff;
  color: #409eff;
  font-size: 12px;
  font-weight: 600;

  &.green {
    background: #f0f9eb;
    color: #67c23a;
  }
}

.album-info {
  flex: 1;
  min-width: 0;
}

/* 素材迷你回显 */
.material-mini-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 8px;
}

.material-mini-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafafa;
  font-size: 12px;

  .mini-dot {
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #f56c6c;
  }

  &.ok .mini-dot {
    background: #67c23a;
  }

  .mini-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #303133;
  }

  .mini-count {
    flex-shrink: 0;
    color: #909399;
  }

  &.ok .mini-count {
    color: #67c23a;
  }
}

/* 提交栏 */
.submit-step {
  border-color: #d9ecff;
  background: linear-gradient(180deg, #f6faff 0%, #fff 60%);
}

.submit-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.submit-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #606266;

  b {
    color: #409eff;
    font-size: 15px;
  }

  .sep {
    color: #dcdfe6;
  }
}

.submit-btn {
  min-width: 160px;
  padding: 10px 24px;
  font-size: 15px;
  letter-spacing: 2px;
}

.form-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.align-start {
  align-items: flex-start;
}

.field-label {
  width: 120px;
  flex-shrink: 0;
  color: #606266;
  line-height: 32px;
}

.field-control {
  flex: 1;
  min-width: 0;
}

/* ============ 专辑链接 ============ */
.album-link-row,
.marketing-row {
  margin-bottom: 16px;
}

.select-display-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 280px;
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #303133;
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: #409eff;
  }
}

.placeholder-text {
  color: #c0c4cc;
}

.select-arrow {
  color: #c0c4cc;
}

.album-link-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.selected-count-text {
  font-size: 13px;
  color: #606266;
}

.material-count-text {
  font-size: 13px;
  color: #303133;
  margin-left: 8px;

  .num-blue {
    color: #409eff;
    font-weight: 600;
  }
}

.clear-link-btn {
  color: #409eff;
}

.selected-album-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.selected-album-item {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 28px 10px 12px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.num-blue {
  color: #409eff;
  font-weight: 600;
}

.selected-album-title {
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-album-id {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

.selected-album-remove {
  position: absolute;
  top: 6px;
  right: 8px;
  color: #c0c4cc;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;

  &:hover {
    color: #f56c6c;
  }
}

/* 专辑链接弹窗 */
.album-dialog-body {
  max-height: 460px;
  overflow-y: auto;
}

.album-dialog-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.album-dialog-item {
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  transition: border-color 0.2s;

  &.active {
    border-color: #409eff;
  }

  :deep(.el-card__body) {
    padding: 10px 12px;
  }

  .el-checkbox {
    position: absolute;
    top: 8px;
    right: 8px;
  }
}

.album-dialog-title {
  max-width: 80%;
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.album-dialog-id {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

/* 创意素材状态列 */
.status-unselected {
  color: #f56c6c;
  font-size: 13px;
}

.status-selected {
  color: #67c23a;
  font-size: 13px;
}

/* 素材搜索栏 */
.sucai-search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.sucai-label {
  flex-shrink: 0;
  font-size: 14px;
  color: #606266;
}

.sucai-range-sep {
  color: #909399;
  margin: 0 -6px;
}

.sucai-duration-input {
  width: 76px;

  :deep(.el-input__inner) {
    height: 28px;
    line-height: 28px;
    padding: 0 6px;
    font-size: 12px;
    text-align: center;
  }
}

/* 素材网格 */
.sucai-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
  max-height: 420px;
  overflow-y: auto;
}

.sucai-grid-item {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s;

  &.active {
    border-color: #409eff;
    box-shadow: 0 0 0 1px #409eff;
  }
}

.sucai-cover {
  position: relative;
  height: 120px;
  background: #f5f7fa;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  /* 选中遮罩，让选中素材更显眼 */
  .sucai-mask {
    position: absolute;
    inset: 0;
    background: rgba(64, 158, 255, 0.25);
    border: 2px solid #409eff;
    box-sizing: border-box;
  }

  .sucai-check {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: #409eff;
    color: #fff;
    border-radius: 50%;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    z-index: 1;
  }
}

.sucai-selected-count {
  font-size: 13px;
  color: #409eff;
}

.sucai-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 6px 8px;
  min-width: 0;
}

.sucai-name {
  width: 100%;
  min-width: 0;
  font-size: 12px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sucai-duration {
  flex-shrink: 0;
  padding: 0 6px;
  font-size: 11px;
  line-height: 18px;
  color: #409eff;
  background: #ecf5ff;
  border-radius: 4px;
  white-space: nowrap;
}

.sucai-pagination {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

/* 选择配置弹窗 */
.strategy-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

/* 选择创意素材弹窗：自动匹配素材工具栏 */
.creative-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.creative-toolbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.creative-toolbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.auto-match-warn {
  font-size: 12px;
  color: #f56c6c;
}

.auto-match-tip {
  font-size: 12px;
  color: #909399;

  &--info {
    color: #e6a23c;
  }

  &--success {
    color: #67c23a;
  }

  &--danger {
    color: #f56c6c;
  }
}

.auto-match-count-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.auto-match-count-label {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

.auto-match-count-unit {
  font-size: 13px;
  color: #909399;
}

.auto-match-count-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #909399;
}

.strategy-confirm-btn {
  margin-left: 28px;
}

.strategy-pagination {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.sucai-org-box {
  width: 280px;
}

/* 素材预览 */
.sucai-preview-list {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sucai-preview-item {
  width: 56px;
  height: 56px;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
}

.sucai-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sucai-preview-more {
  font-size: 13px;
  color: #909399;
}

.sucai-preview-empty {
  font-size: 12px;
  color: #909399;
}

/* 基础信息配置回显 */
.config-summary-box {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 10px;
  margin-top: 4px;
  padding: 12px 14px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.config-summary-item {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 13px;
  color: #606266;
}

.summary-label {
  flex-shrink: 0;
  color: #909399;
}

.summary-value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #303133;
}

/* 分账户指定抖音号 */
.per-account-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}

.account-cell-name {
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-cell-id {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}
</style>